var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "galleryGridWrapp" }, [
    _vm.errorStatus
      ? _c(
          "div",
          {
            staticClass: "container flex justify-center text-red text-center",
            attrs: { fade: "", "fade-trigger": "scroll" },
          },
          [
            _c("h2", { staticClass: "title h3" }, [
              _vm._v(_vm._s(_vm.errorMessage)),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "grid grid-cols-1 md:grid-cols-2 md:pb-10 border-t border-[#EDEDED]",
      },
      _vm._l(_vm.images, function (image, index) {
        return _c("gallery-item", {
          key: index,
          attrs: { src: image.src, alt: image.alt, index: index },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }